import axios from "axios";
import React, { useState, useEffect } from "react";
import { Link, Navigate } from "react-router-dom";
import { Card, Button, Dialog, Snackbar, TextField, Typography, CardContent, InputAdornment } from "@mui/material";
import { Close, VpnKey, Email } from "@mui/icons-material";
import { C, D, Loading, openLink, obj2form } from "./include";
import { MainPage } from "./views/Main";

class Screen extends React.Component {
  render() {
    return (
      <D
        className="r2c e aF"
        style={{ backgroundColor: "#424242", padding: "30px" }}
      >
        <D className="e hide-sm" />
        <D className="col e aF" p="3">
          <D className="e hide-sm" />
          <D h="30px" />
          <D col p="2" img={C.coverImg} side />
          <Typography className="row w aC" variant="h3" color="white">
            {C.appName}
          </Typography>
          <D
            className="row w aC hv"
            onClick={() => openLink("http://www.metadox.com.br/")}
          >
            <Typography variant="subtitle1" color="white">
              <b>Criado por Metadox</b>
            </Typography>
            <img
              style={{ marginLeft: "10px", height: "20px" }}
              src="/static/metadox.png"
              alt="logo"
            />
          </D>
          <D className="e hide-sm" />
        </D>
        <D className="e hide-sm" />
        <D className="col e aF" p="3">
          <D className="e hide-sm" />
          <D className="row aC">
            <Card className="row aF" square style={{ minWidth: "350px" }}>
              <CardContent className="col e aF">
                <D h="1rem" />
                {this.props.children}
                <D h="1rem" />
              </CardContent>
            </Card>
          </D>
          <D e />
        </D>
        <D className="e hide-sm" />
      </D>
    );
  }
}

function Login(props) {
  const [email, setEmail] = useState("");
  const [pwd, setPwd] = useState("");
  const [snackbar, setSnackbar] = useState(false);
  const [snackbarMsg, setSnackbarMsg] = useState("");

  const handleSubmit = (event) => {
    event.preventDefault();
    props.doLogin(email, pwd);
  };

  return (
    <Screen>
      <Typography variant="h6" className="row w aC">
        Acesso
      </Typography>
      <D h="1rem" />
      <form onSubmit={handleSubmit} className="col w aF">
        <TextField
          type="email"
          name="email"
          label="E-mail"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          fullWidth
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <Email color="action" />
              </InputAdornment>
            ),
          }}
        />
        <D h="1rem" />
        <TextField
          type="password"
          name="password"
          label="Senha"
          value={pwd}
          onChange={(e) => setPwd(e.target.value)}
          required
          fullWidth
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <VpnKey color="action" />
              </InputAdornment>
            ),
          }}
        />
        <D h="1rem" />
        <D className="row w aC">
          <Button type="submit" variant="contained" color="primary">
            Entrar
          </Button>
        </D>
      </form>
      <D h="1rem" />
      <D className="row w aC">
        <Link to="/forgot-password">
          <Typography variant="caption">Esqueceu a senha?</Typography>
        </Link>
      </D>
      <Snackbar
        open={snackbar}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        autoHideDuration={6000}
        action={<Close onClick={() => setSnackbar(false)} />}
        message={snackbarMsg}
        onClose={() => setSnackbar(false)}
      />
    </Screen>
  );
}

function ResetPassword() {
  const [snackbar, setSnackbar] = useState(false);
  const [snackbarMsg, setSnackbarMsg] = useState("");
  const [email, setEmail] = useState("");
  const [hash, setHash] = useState("");
  const [pwd, setPwd] = useState("");
  const [pwdConfirm, setPwdConfirm] = useState("");
  const [goToLogin, setGoToLogin] = useState(null);

  useEffect(() => {
    const path = window.location.pathname.split("/");
    setEmail(path[3]);
    setHash(path[2]);
    setPwd("");
    setPwdConfirm("");
  }, []);

  const alert = (message) => {
    setSnackbar(true);
    setSnackbarMsg(message);
  };

  const changePwd = (event) => {
    event.preventDefault();
    if (pwd === pwdConfirm) {
      axios
        .put(
          `${C.baseURL}updatePassword/${hash}/${email}`,
          { password: pwd },
          { timeout: 2000 }
        )
        .then((response) => {
          alert("Senha alterada com sucesso");
          setGoToLogin(<Navigate replace to="/" />);
        })
        .catch((error) => {
          alert("Não foi possível alterar a senha, link inválido");
        });
    } else {
      alert("A senha e a confirmação precisam ser iguais");
    }
  };

  return (
    <Screen>
      <Typography variant="h6" className="row w aC">
        Troca de senha
      </Typography>
      <D h="1rem" />
      <form onSubmit={changePwd} className="col w aF">
        <TextField
          type="email"
          name="email"
          value={email}
          label="Email"
          onChange={(e) => setEmail(e.target.value)}
          validations="isEmail"
          validationErrors={{ isEmail: "Email inválido" }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <Email />
              </InputAdornment>
            ),
          }}
          variant="outlined"
          required
          fullWidth
        />
        <TextField
          type="password"
          name="password"
          label="Senha"
          value={pwd}
          onChange={(e) => setPwd(e.target.value)}
          required
          validations={{ minLength: 4 }}
          validationErrors={{ minLength: "Muita curta" }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <VpnKey color="action" />
              </InputAdornment>
            ),
          }}
          variant="outlined"
          fullWidth
        />
        <TextField
          type="password"
          name="passwordConfirm"
          label="Confirmar Senha"
          value={pwdConfirm}
          onChange={(e) => setPwdConfirm(e.target.value)}
          required
          validations={{ minLength: 4 }}
          validationErrors={{ minLength: "Muita curta" }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <VpnKey color="action" />
              </InputAdornment>
            ),
          }}
          variant="outlined"
          fullWidth
        />
        <D className="row w aC">
          <Button type="submit" variant="contained" color="primary">
            Trocar senha
          </Button>
        </D>
      </form>
      <D h="1rem" />
      <D className="row w aC">
        <Link to="/login">
          <Typography variant="caption">Voltar para login</Typography>
        </Link>
      </D>
      {goToLogin}
      <Snackbar
        open={snackbar}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        autoHideDuration={6000}
        action={<Close onClick={() => setSnackbar(false)} />}
        message={snackbarMsg}
        onClose={() => setSnackbar(false)}
      />
    </Screen>
  );
}

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [snackbar, setSnackbar] = useState(false);
  const [snackbarMsg, setSnackbarMsg] = useState("");

  const alert = (message) => {
    setSnackbar(true);
    setSnackbarMsg(message);
  };

  const changePwdRequest = (event) => {
    event.preventDefault();
    axios
      .post(C.baseURL + "forgotPassword", obj2form({ email: email }))
      .then((response) => {
        if (response.data.email === email) {
          alert("Enviamos um email com as orientações para a troca de senha");
        } else {
          alert("Não encontramos um usuário com este email");
        }
      })
      .catch((error) => alert("Ocorreu um erro"));
  };

  return (
    <Screen>
      <Typography variant="h6" className="row w aC">
        Recuperar minha senha
      </Typography>
      <D h="1rem" />
      <form onSubmit={changePwdRequest}>
        <TextField
          type="email"
          name="email"
          value={email}
          label="Email"
          onChange={(e) => setEmail(e.target.value)}
          validations="isEmail"
          validationErrors={{ isEmail: "Email inválido" }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <Email />
              </InputAdornment>
            ),
          }}
          variant="outlined"
          required
          fullWidth
        />
        <D h="1rem" />
        <D className="row w aC">
          <Button variant="contained" type="submit">
            Enviar
          </Button>
        </D>
      </form>
      <D h="1rem" />
      <D className="row w aC">
        <Link to="/login">
          <Typography variant="caption">Voltar para login</Typography>
        </Link>
      </D>
      <Snackbar
        open={snackbar}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        autoHideDuration={6000}
        action={<Close onClick={() => setSnackbar(false)} />}
        message={snackbarMsg}
        onClose={() => setSnackbar(false)}
      />
    </Screen>
  );
}

class NotFound extends React.Component {
  render() {
    return (
      <D
        className="row e aF fullH aF"
        style={{ backgroundColor: "#424242", padding: "30px" }}
      >
        <D e />
        <D className="col e aF" p="3">
          <D e h="3rem" />
          <D col p="2" img={C.coverImg} side />
          <D e h="3rem" />
          <Typography className="row w aC" variant="h5" color="white">
            Página não encontrada
          </Typography>
          <D e h="3rem" />
          <Typography className="row w aC" variant="h3" color="white">
            {C.appName}
          </Typography>
          <D
            className="row w aC hv"
            onClick={() => openLink("http://www.metadox.com.br/")}
          >
            <Typography variant="subtitle1" color="white">
              <b>Criado por Metadox</b>
            </Typography>
            <img
              style={{ marginLeft: "10px", height: "20px" }}
              src="/static/metadox.png"
              alt="logo"
            />
          </D>
          <D e h="3rem" />
        </D>
        <D e />
      </D>
    );
  }
}

class Auth extends React.Component {
  constructor(props) {
    super(props);
    this.alert = this.alert.bind(this);
    this.dialog = this.dialog.bind(this);
    this.dialogClose = this.dialogClose.bind(this);
    this.setToken = this.setToken.bind(this);
    this.getToken = this.getToken.bind(this);
    this.updateAppData = this.updateAppData.bind(this);
    this.handleAuthentication = this.handleAuthentication.bind(this);
    this.signInWithToken = this.signInWithToken.bind(this);
    this.logout = this.logout.bind(this);
    this.login = this.login.bind(this);
    this.state = {
      authorized: false,
      snackbar: false,
      snackbarMsg: "",
      dialogOpen: false,
      dialogChildren: [],
      token: this.getToken(),
      loginScreen: <Loading style={{ backgroundColor: "#424242" }} />,
    };
    this.api = axios.create({ baseURL: C.baseURL });
    this.api.interceptors.response.use(
      (res) => {
        if (res.data.status === "NoApiAccess") {
          this.alert("Você não tem acesso a esta funcionalidade.");
          return {};
        }
        return res.data;
      },
      (err) => {
        if (
          !!err.response &&
          err.response.status === 401 &&
          err.config &&
          !err.config.__isRetryRequest
        ) {
          this.alert("Sessão expirada, entre com seus dados de acesso.");
          console.log("Auth.jsx: this.api.interceptors.response.use\nSessão expirada, entre com seus dados de acesso.")
        } else {
          this.alert("Erro ao conectar com servidor");
          console.log("Auth.jsx: this.api.interceptors.response.use\nErro ao conectar com servidor")
        }
        return {};
      }
    );
  }

  componentDidMount = () => this.handleAuthentication();

  alert = (m) => this.setState({ snackbar: true, snackbarMsg: m });

  dialog = (m) => this.setState({ dialogOpen: true, dialogChildren: m });

  dialogClose = () => this.setState({ dialogOpen: false, dialogChildren: [] });

  setToken = (t) => {
    if (!!t) {
      if (!!localStorage) {
        localStorage.setItem("jwt_access_token", t);
      }
      this.api.defaults.headers.common["Authorization"] = "Bearer " + t;
      this.setState({ token: t });
    } else {
      localStorage.removeItem("jwt_access_token");
      delete this.api.defaults.headers.common["Authorization"];
      this.setState({ token: "" });
    }
  };

  getToken = () =>
    !!localStorage &&
    (!!localStorage.getItem("jwt_access_token")
      ? localStorage.getItem("jwt_access_token")
      : "");

  handleAuthentication = () => {
    if (!!this.props.logout) {
      this.logout();
    } else {
      let tk = this.getToken();
      if (!!tk) {
        this.setToken(tk);
        this.signInWithToken();
      } else {
        this.logout();
      }
    }
  };

  updateAppData = (callback) => {
    this.api
      .post("/auth/access-token", { access_token: this.state.token })
      .then((r) => {
        if (!!r.user) {
          this.setToken(r.access_token);
          this.api.get("/getRoles").then((p) => {
            let permissions = [];
            for (const [k, v] of Object.entries(p)) {
              v.forEach((rl) => r.user.role === rl && permissions.push(k));
            }
            const u = { ...r.user, permissions };
            this.setState(
              {
                loginScreen: (
                  <MainPage
                    api={this.api}
                    user={u}
                    logout={this.logout}
                    alert={this.alert}
                    dialog={this.dialog}
                    dialogClose={this.dialogClose}
                    updateAppData={this.updateAppData}
                  />
                ),
              },
              () => (typeof callback === "function" ? callback() : null)
            );
          });
        } else {
          this.logout();
        }
      })
      .catch(() => this.logout());
  };

  signInWithToken = () =>
    this.updateAppData(() => this.alert("Sessão iniciada com sucesso"));

  login = (email, password) => {
    if (!!email && !!password) {
      this.api
        .post("/sessions", { email: email, password: password })
        .then((r) => {
          if (!r.error && r.user.email === email) {
            this.setToken(r.access_token);
            this.api
              .get("/getRoles")
              .then((p) => {
                let permissions = [];
                for (const [k, v] of Object.entries(p)) {
                  v.forEach((rl) => r.user.role === rl && permissions.push(k));
                }
                const u = { ...r.user, permissions };
                this.setState({
                  loginScreen: (
                    <MainPage
                      api={this.api}
                      user={u}
                      logout={this.logout}
                      alert={this.alert}
                      dialog={this.dialog}
                      dialogClose={this.dialogClose}
                      updateAppData={this.updateAppData}
                    />
                  ),
                });
                this.alert("Sessão iniciada com sucesso");
              })
              .catch(() => this.logout());
          } else {
            this.alert("Usuário ou senha incorretos!");
          }
        })
        .catch(() => this.logout());
    }
  };

  logout = () => {
    this.setToken("");
    this.setState({
      authorized: false,
      loginScreen: !!this.props.logout ? (
        <Navigate to="/" replace />
      ) : (
        <Login doLogin={(u, p) => this.login(u, p)} />
      ),
    });
  };

  render() {
    return (
      <D className="row e aF scD">
        <>{this.state.loginScreen}</>
        <Dialog open={this.state.dialogOpen} onClose={this.dialogClose} >
          {this.state.dialogChildren}
        </Dialog>
        <Snackbar
          open={this.state.snackbar}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          autoHideDuration={7000}
          action={
            <Close
              onClick={() =>
                this.setState({ snackbar: false, snackbarMsg: "" })
              }
            />
          }
          message={this.state.snackbarMsg}
          onClose={() => this.setState({ snackbar: false, snackbarMsg: "" })}
        />
      </D>
    );
  }
}

export { Login, ResetPassword, ForgotPassword, NotFound, Auth };
